import RecipesService from 'services/recipes';
import { FirebaseNotFoundError } from 'services/recipes/read';

const readRecipe = async (id) => {
  if (!id) throw new Error('id cannot be empty');

  try {
    const recipeModel = await RecipesService.read(id);

    return recipeModel;
  } catch (error) {
    if (error instanceof FirebaseNotFoundError) throw new NotFoundError();

    throw error;
  }
};

export class NotFoundError extends Error {}

export default readRecipe;
